import React from "react";
import { Divider, Tooltip } from "antd";
import CustomTitle from "../../../components/CustomTitle";
import NotificationListItem from "./NotificationListItem";
import { useNavigate } from "react-router-dom";
import EmptyState from "./EmptyState";

const NotificationListSection = ({
  title,
  list,
  isCompanyLevel,
  onCreate,
  onEdit,
  onDelete,
}) => {
  const navigate = useNavigate();

  return (
    <>
      {isCompanyLevel ? (
        <Tooltip
          title="Previously created notifications that apply to products in this shipment"
          placement="topLeft"
        >
          <p
            style={{
              textDecoration: "underline dotted",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 600,
              marginBottom: "12px",
            }}
          >
            {`${title} (${list?.length || 0})`}
          </p>
        </Tooltip>
      ) : (
        <CustomTitle
          text={`${title} (${list?.length || 0})`}
          fontSize="14px"
          fontWeight="600"
          marginTop={16}
          marginBottom="12px"
        />
      )}

      {Array.isArray(list) && list?.length > 0 ? (
        list.map((item) => (
          <React.Fragment key={item.id}>
            {item !== list[0] && <Divider style={{ margin: "12px 0" }} />}
            <NotificationListItem
              item={item}
              visible={isCompanyLevel ? true : false}
              isCompanyLevel={isCompanyLevel}
              onEdit={() => onEdit?.(item)}
              onDelete={() => onDelete?.(item)}
            />
          </React.Fragment>
        ))
      ) : (
        <EmptyState
          message="None exist yet. Create one"
          linkText="here."
          fontWeight={600}
          onClick={
            isCompanyLevel ? () => navigate("/settings/notification") : onCreate
          }
        />
      )}
    </>
  );
};

export default NotificationListSection;
